import { required, minValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    form: {
      name: {
        required: helpers.withMessage(i18n.global.t('Please enter a group name.'), required)
      },
      point_multiplier: {
        minValue: helpers.withMessage(i18n.global.t('Must be 0 or more.'), minValue(0))
      }
    }
  }
};
